import { useNavigate } from "react-router-dom";
// import tokenService from "../../../api/TokenService";
import { signOut } from "@aws-amplify/auth";
import { Button } from "@mui/material";
import { borderStyle, defaultGap } from "../../../styles/consts";
import Icon from "../fundamentals/Icon";

export default function Logout() {
  const navigate = useNavigate();

  const logout = async () => {
    await signOut();
    // Clear alqemi-related localStorage items
    localStorage.removeItem("alqemiFilters");
    localStorage.removeItem("alqemiOffersPage");
    navigate("/");
    window.location.reload();
  };
  return (
    <Button
      variant="transparentSmall"
      id="logout"
      sx={{
        width: defaultGap,
        borderLeft: borderStyle,
        borderBottom: borderStyle,
      }}
      onClick={() => {
        logout();
      }}
    >
      <Icon name="Logout" />
    </Button>
  );
}
